
import { TranslationRecord } from '../../types';

export const reviews: TranslationRecord = {
  // Reviews Section
  title: 'Τι Λένε οι Επισκέπτες μας',
  subtitle: 'Ανακαλύψτε γιατί οι επισκέπτες επιλέγουν το Loena Luxury Suites για την εμπειρία τους στη Θεσσαλονίκη.',
  reviewsTitle: 'Κριτικές Επισκεπτών',
  guestReviews: 'Κριτικές Επισκεπτών',
  reviewsCount: 'Κριτικές',
  
  // Rating and stats
  overallRating: 'Συνολική Αξιολόγηση',
  basedOnReviews: 'Βασισμένο σε κριτικές επισκεπτών',
  excellent: 'Εξαιρετικό',
  veryGood: 'Πολύ Καλό',
  good: 'Καλό',
  average: 'Μέτριο',
  poor: 'Κακό',
  
  // Review categories
  cleanliness: 'Καθαριότητα',
  location: 'Τοποθεσία',
  service: 'Εξυπηρέτηση',
  value: 'Αξία για τα Χρήματα',
  amenities: 'Παροχές',
  comfort: 'Άνεση',
  
  // Actions
  readMore: 'Διαβάστε Περισσότερα',
  readLess: 'Διαβάστε Λιγότερα',
  writeReview: 'Γράψτε Κριτική',
  allReviews: 'Όλες οι Κριτικές',
  
  // Review metadata
  reviewedOn: 'Κριτική στις',
  verifiedGuest: 'Επαληθευμένος Επισκέπτης',
  stayedFor: 'Έμεινε για',
  nights: 'νύχτες',
  
  // Review responses
  managementResponse: 'Απάντηση από τη Διεύθυνση',
  thankYou: 'Ευχαριστούμε για την κριτική σας!',
  
  // Call to Action
  readyToExperienceLoena: 'Έτοιμοι να Βιώσετε την Πολυτέλεια του Loena;',
  joinSatisfiedGuests: 'Γίνετε μέλος εκατοντάδων ικανοποιημένων επισκεπτών που έχουν κάνει το Loena το σπίτι τους στη Θεσσαλονίκη.',
  bookYourStay: 'Κράτηση Διαμονής',
  contactUs: 'Επικοινωνήστε Μαζί μας',
  
  // Additional keys needed
  suitesTitle: 'Πολυτελείς Σουίτες',
  suitesSubtitle: 'Βιώστε τη σύγχρονη άνεση στις προσεκτικά σχεδιασμένες σουίτες μας των 35m², ιδανικές για ζευγάρια ή μικρές οικογένειες.',
  locationTitle: 'Προνομιακή Τοποθεσία',
  locationSubtitle: 'Βιώστε τη Θεσσαλονίκη από την προνομιακή μας τοποθεσία. Όλα όσα χρειάζεστε βρίσκονται σε κοντινή απόσταση.',
};
